/**
 * Simple view showing your current renewal status with a link to take you to the
 * "edit renew settings" page.
 */
import Backbone from "backbone";

import * as mustcache from "mustcache";
import * as dateUtils from "shared/dateUtils";

const AccountRenewalView = Backbone.View.extend({
  /**
   * model : user
   */
  initialize: function (options) {
    this.options = options;
    this.render();
  },
  render: function () {
    const data: { [key: string]: any } = {};

    data.paymentMethod = {};
    data.paymentMethod[this.model.get("paymentMethod")] = true;
    data.expiryDate = new Date(
      dateUtils.parse(this.model.get("subscriptionExpiryDate"))
    );
    data.expiryDateString = data.expiryDate.toDateString();

    if (
      this.model.get("renewalMonths") &&
      this.model.get("renewalMonths") > 0
    ) {
      data.renewEnabled = true;
    }

    mustcache.render("renewalView", data, (html) => {
      this.$el.html(html);

      const renewalMonths = this.model.get("renewalMonths") || 0;
      this.$el
        .find('.renewal [data-months="' + renewalMonths + '"]')
        .prop("selected", true);

      if (renewalMonths !== 3) {
        this.$el.find('.renewal [data-months="3"]').remove();
      }
    });
  },
  events: {},
});

export default AccountRenewalView;
